module.exports = {"page_faq":"HELP CENTER","page_legal":"TERMS","footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"09:00-21:00","error_message_please_enter_telephone_number":"Please enter a valid Indian phone number.","footer_copyright":[""],"need_help_call_us":"Need help? Call ","need_help_number":"75500 46469"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/general/locale.json
// module id = 543
// module chunks = 0 1 2 3 4 5